import { formatMoney } from '../../../../utils/lookahead-common';

export const testIds = {
  RENDER_DURATION_CONTAINER: 'RENDER_DURATION_CONTAINER'
};
export const testWrapped = (children = '') =>
  `<span data-testid=${testIds.RENDER_DURATION_CONTAINER}>${children}</span>`;

export const isTaskDisabled = (taskFromLookahead) =>
  taskFromLookahead ? taskFromLookahead.children.length > 0 : true;

export const formatValueData = (valueData, navigatorLang) => {
  if (valueData !== 0 && !navigatorLang.includes('en')) {
    const numbers = valueData.split('.');
    return numbers.length > 1
      ? numbers[0].replaceAll(',', '.') + ',' + numbers[1]
      : numbers[0].replaceAll(',', '.');
  }
  return valueData;
};

export const renderNonTask = (task, column, t) => {
  const evenNumber = 2;
  const formatter = window.ganttVisualization?.formatter;
  const formatted = formatter?.format(task[column.name])?.split('day')[0];
  const decimalPlaces = Number.isInteger(
    parseFloat(formatter?.format(task[column.name]))
  )
    ? 0
    : evenNumber;
  const lang = t('lang') === 'en';

  return testWrapped(`
    <div>
      <span class="vertical-center-dates">
        <span class="column-disabled">
          ${formatMoney(
            formatted,
            '',
            decimalPlaces,
            lang ? '.' : ',',
            lang ? ',' : '.'
          )}
        </span>
      </span>
    </div>`);
};

const getIsOdd = (task, column) => {
  let isOdd = false;
  if (
    window.ganttVisualization?.oddColsConfig &&
    task.type === 'activitytask'
  ) {
    isOdd = window.ganttVisualization.oddColsConfig[column.name];
  }
  return isOdd;
};

export const renderTaskContent = (
  taskFromLookahead,
  column,
  t,
  { valueData, disabled, task }
) => {
  const isOdd = getIsOdd(task, column);
  let content = '';
  const evenNumber = 2;
  if (disabled) {
    if (taskFromLookahead) {
      const value =
        t('lang') === 'en'
          ? taskFromLookahead[column.name].toFixed(
              Number.isInteger(parseFloat(taskFromLookahead[column.name]))
                ? 0
                : evenNumber
            )
          : taskFromLookahead[column.name]
              .toFixed(
                Number.isInteger(parseFloat(taskFromLookahead[column.name]))
                  ? 0
                  : evenNumber
              )
              .replace('.', ',');

      content = `<span class="vertical-center 11">${value}</span>`;
    }
  } else {
    content = `<span class="vertical-center cost-fix-gantt 22" style="padding-left: 19;">${valueData}</span>`;
  }

  return `<div class="${isOdd ? 'odd-col' : 'non-odd-col'}">${content}</div>`;
};
